/**
 * LandingPage — public marketing page shown to unauthenticated visitors
 * at the root ("/") of the app.
 *
 * This file is intentionally a thin orchestrator: it wires up page-level
 * concerns (meta tags, stats fetch) and composes the section components
 * in visual order. To add/remove/reorder sections, edit the JSX below.
 * To edit a section's content or markup, open that section's file.
 */

import { useTranslation } from 'react-i18next';

import { PageMeta } from '../../../components/PageMeta';
import { VlPage } from '../common/LandingPage.styled';
import { PublicFooter } from '../common/PublicFooter';

import {
  LandingNav,
  HeroSection,
  StatsSection,
  FeaturesSection,
  ForReadersSection,
  TestimonialsSection,
  HowItWorksSection,
  PricingSection,
  ComparisonSection,
  FinalCtaSection,
  AiTransparencySection,
} from './sections';

import { useLandingStats } from './useLandingStats';

export default function LandingPage() {
  const { t } = useTranslation();
  const stats = useLandingStats();
  const showStats =
    stats.writers.value > 50 &&
    stats.journals.value > 0 &&
    stats.subscriptions.value > 0 &&
    stats.paidOut.value > 1000;

  return (
    <>
      <PageMeta title="" description={t('landing.meta.description')} />
      <VlPage>
        <LandingNav />
        <HeroSection writers={stats.writers} />
        {showStats && (
          <StatsSection
            writers={stats.writers}
            journals={stats.journals}
            subscriptions={stats.subscriptions}
            paidOut={stats.paidOut}
          />
        )}
        <FeaturesSection />
        <ForReadersSection />
        <TestimonialsSection />
        <HowItWorksSection />
        <PricingSection />
        <ComparisonSection />
        <FinalCtaSection writers={stats.writers} />
        <AiTransparencySection />
        <PublicFooter />
      </VlPage>
    </>
  );
}
